import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex } from '@bonusly/design-system';

interface RescheduleModalFooterProps {
	isSubmitting: boolean;
	onClose: VoidFunction;
	onOpenCancelModal: VoidFunction;
}

export const RescheduleModalFooter: FC<RescheduleModalFooterProps> = ({ onClose, onOpenCancelModal, isSubmitting }) => {
	const { t } = useTranslation(['common', 'one_on_ones']);

	const openCancelConfirmation = () => {
		onOpenCancelModal();
		onClose();
	};

	return (
		<>
			<Button colorScheme="secondary" variant="alpha" ml={0} onClick={openCancelConfirmation}>
				{t('one_on_ones:meeting.menu.cancel')}
			</Button>

			<Flex justifyContent="flex-end">
				<Button color="primary.fg" isDisabled={isSubmitting} onClick={onClose} variant="ghost">
					{t('common:cancel')}
				</Button>

				<Button colorScheme="primary" isActive={isSubmitting} type="submit">
					{t('one_on_ones:meeting.reschedule_modal.form.submit')}
				</Button>
			</Flex>
		</>
	);
};
